class FlipCard extends HTMLElement {
  constructor() {
    super()
    this.front = this.querySelector('[data-card-front]')
    this.back = this.querySelector('[data-card-back]')
    this.close = this.querySelector('[data-card-close]')
    this.isFlipped = false
    this.fullWidthMobile = this.dataset.fullWidthMobile === 'true'

    // Set initial styles
    this.style.perspective = '1000px'
    this.style.cursor = 'pointer'
    this.style.position = 'relative'
    this.style.display = 'block'

    // Setup front and back initial styles
    ;[this.front, this.back].forEach(el => {
      if (el) {
        el.style.backfaceVisibility = 'hidden'
        el.style.transition = 'transform 0.6s'
        el.style.transformStyle = 'preserve-3d'
        el.style.position = 'absolute'
        el.style.top = '0'
        el.style.left = '0'
        el.style.width = '100%'
        el.style.height = '100%'
      }
    })

    // Hide back side initially
    if (this.back) {
      this.back.style.transform = 'rotateY(180deg)'
    }
  }

  connectedCallback() {
    this.addEventListener('click', () => this.toggleCard())
    if (this.close) {
      this.close.addEventListener('click', e => {
        e.stopPropagation() // Prevent event from bubbling to the card
        this.closeCard()
      })
    }

    // Calculate dimensions based on the largest card
    this.calculateDimensions()
  }

  calculateDimensions() {
    // Store original transform states
    const frontTransform = this.front ? this.front.style.transform : ''
    const backTransform = this.back ? this.back.style.transform : ''

    // Temporarily reset transforms to get accurate measurements
    if (this.front) this.front.style.transform = 'none'
    if (this.back) this.back.style.transform = 'none'

    // Get the dimensions of both cards
    let frontRect = this.front ? this.front.getBoundingClientRect() : { width: 0, height: 0 }
    let backRect = this.back ? this.back.getBoundingClientRect() : { width: 0, height: 0 }

    // Restore original transforms
    if (this.front) this.front.style.transform = frontTransform
    if (this.back) this.back.style.transform = backTransform

    // Use the maximum dimensions, ensuring minimum sizes
    const contentWidth = Math.max(frontRect.width, backRect.width, 251) // Default/desktop content width
    const height = Math.max(frontRect.height, backRect.height, 220)

    const isMobile = window.innerWidth < 768 // Define your mobile breakpoint

    // Set container dimensions
    if (this.fullWidthMobile && isMobile) {
      this.style.width = '100%'
    } else {
      this.style.width = `${contentWidth}px`
    }
    this.style.height = `${height}px`
  }

  toggleCard() {
    this.isFlipped = !this.isFlipped

    if (this.isFlipped) {
      // Show back, hide front
      if (this.front) this.front.style.transform = 'rotateY(180deg)'
      if (this.back) this.back.style.transform = 'rotateY(0deg)'
    } else {
      // Show front, hide back
      if (this.front) this.front.style.transform = 'rotateY(0deg)'
      if (this.back) this.back.style.transform = 'rotateY(180deg)'
    }
  }

  closeCard() {
    if (this.isFlipped) {
      this.toggleCard() // Flip back to front if card is flipped
    }
  }
}

if (!customElements.get('flip-card')) {
  customElements.define('flip-card', FlipCard)
}
